/** Правила показа приёмки, общие для всех её экранов.
 *
 * Заведён из-за одного вопроса, который решался в пяти местах четырьмя
 * разными способами: как назвать приход, у которого документа не было.
 */
import type { BatchView, DeliveryView, ReviewDeliveryCard } from "@/api/receiving";

type UpdCarrier = Pick<DeliveryView, "incoming_number"> & { upd_missing?: boolean };

/**
 * Как назвать УПД прихода.
 *
 * ⚠️ Служебный ключ портала («б/н 20.08.2026») человеку не показываем НИКОГДА:
 * он ни на одной накладной не написан, и оператор 1С пойдёт искать документ,
 * которого нет. Номер там есть всегда — приходы им и различаются, — поэтому
 * решает флаг, а не пустота.
 */
export function updTitle(d: UpdCarrier | null | undefined): string {
  if (!d) return "";
  if (d.upd_missing) return "без УПД";
  return d.incoming_number ? `УПД ${d.incoming_number}` : "без УПД";
}

/** Тот же ответ без слова «УПД» — для таблиц, где оно в заголовке колонки. */
export function updNumber(d: UpdCarrier | ReviewDeliveryCard | null | undefined): string {
  if (!d) return "—";
  return d.upd_missing || !d.incoming_number ? "без УПД" : d.incoming_number;
}

/**
 * Как назвать принятую позицию: партией — только если она есть.
 *
 * У непартионных категорий (тара, упаковка, полиграфия) партия в 1С не
 * заводится, и «партия 12» отправляло бы кладовщика искать в справочнике то,
 * чего там нет.
 */
export function partiaSuffix(batch: Pick<BatchView, "partia_number">): string {
  return batch.partia_number ? ` · партия ${batch.partia_number}` : "";
}

/** Родительный падеж для сообщений: «у партии 12» / «у позиции». */
export function batchLabel(batch: Pick<BatchView, "partia_number">): string {
  return batch.partia_number ? `у партии ${batch.partia_number}` : "у позиции";
}
